import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'

import { EmptyState, ToastContainer, Tooltip } from 'mailup-web-components'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import Header from './Header'
import TrendChart from './TrendChart'
import TrendTable from './TrendTable'
import { resultsStateEmptyState } from './recoil/state/result'

import Page from 'Containers/Page'

import {
  getRecipientCallback,
  laodTrendTableCallback,
  resetPageCallback,
} from './recoil/callbacks/callbacks'

const ProfileTrend = () => {
  const intl = useIntl()

  const isEmptyState = useRecoilValue(resultsStateEmptyState)
  const { idRecipient } = useParams()
  const getRecipient = useRecoilCallback(getRecipientCallback, [])
  const laodTrendTable = useRecoilCallback(laodTrendTableCallback, [])
  const resetPage = useRecoilCallback(resetPageCallback, [])

  const initPage = () => {
    getRecipient(idRecipient)
    laodTrendTable({ idRecipient })
  }

  useEffect(() => {
    initPage()

    return () => {
      resetPage()
    }
  }, [])

  return (
    <>
      <Tooltip />
      <Header />
      <ToastContainer />
      <Page onReload={initPage}>
        {isEmptyState ? (
          <EmptyState
            title={intl.formatMessage({
              id: 'Load.EmailMessageList.EmptyStateActiveRecipientTrendTitle',
            })}
            description={intl.formatMessage({
              id: 'Load.EmailMessageList.EmptyStateActiveRecipientTrendDescription',
            })}
          />
        ) : (
          <>
            <TrendChart />
            <TrendTable />
          </>
        )}
      </Page>
    </>
  )
}

export default ProfileTrend
